<template>
  <div class="employeeLIstVue" v-loading.fullscreen.lock="loadingShow">
    <div class="o-main-content-area">
        <div class="row c-responsive-fixwidth">
            <div class="col-md-3">
                <h1 class="h1">Employees</h1>
            </div>
            <div class="col-md-9 text-right">
                <ul class="o-filter-area">

                    <li class="o-search-field">
                        <div class="input-group stylish-input-group">
                            <input id="search-input-employee" type="text" class="form-control" placeholder="Search" v-model="search_query" v-on:keyup="getEmployeesBySearch()" autofocus>
                            <span class="input-group-addon">
                                <button type="submit">
                                <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                            </button>
                            </span>
                        </div>
                    </li>
                    <li v-if="false"><a href="javascript: void(0)" @click="deleteEmployee()" class="c-common-btn c-common-btn--inverse-icon-red"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete Employee</a></li>
                </ul>
                <div class="o-add-employee-bar text-right">
                    <div class="o-cutsomSelect o-display-inline o-add-template-select">
                        <select v-model="selectedTemplate" @change="onTemplateSelect()" class="form-control fix-width-input">
                            <option value="">Add Templates</option>
                            <option v-for="template in templates" :key="template.id" :value="template.id">{{ template.profile_name }}{{ template.is_default ? ' (default)' : '' }}</option>
                        </select>
                    </div>
                    <a href="javascript: void(0)" @click="addEmployee()" :class="{'isDisabled':!getPower('addEmployee')}" class="c-solid-btn c-solid-btn--green o-add-employee-btn"><i class="fa fa-plus" aria-hidden="true"></i> Add new Employee</a>
                </div>
            </div>
        </div>
    </div>

    <div class="o-ndividualArea c-responsive-fixwidth">
        <div class="o-ndividualTable">

            <div class="c-common-space o-individual-calls">
                <div class="col-md-8 o-no-padding">
                    <form class="form-inline">
                        <div class="form-group o-margin-right-10">
                        <label for="exampleInputEmail3" class="common-label-text">Status Level</label>
                            <div class="o-cutsomSelect o-display-inline">
                                <select v-model="selectedStatusId" @change="getAllEmployee()" class="form-control fix-width-input">
                                    <option v-for="(status,index) in statusList" :key=index :value="status.id">{{status.name}}</option>
                                    <option value="all">All</option>
                                </select>
                            </div>
                        </div>
                    <div class="form-group ">
                        <label for="exampleInputEmail3" class="common-label-text">Sort By</label>
                        <div class="o-cutsomSelect o-display-inline">
                            <select v-model="selectedSortType" @change="getAllEmployee()" class="form-control fix-width-input">
                                <option value="fname_asc">FirstLast (Employee name)</option>
                                <option value="fname_desc">LastFirst (Employee name)</option>
                                <option value="seniority">Seniority </option>
                                <option value="email">Email ID</option>      
                                <option value="member_since">Member Since</option>      
                                <option value="date_of_hire">Date of Hire</option>      
                            </select>
                        </div>
                    </div>
                    </form>
                </div>
            </div>

            <div class="o-skills-listing">
                <div class="row">
                    <div class="col col-sm-12">
                        <div class="o-scheduleTable--daily">
                            <div 
                                infinite-scroll-disabled="busy" 
                                infinite-scroll-distance="10" 
                                v-loading="loading"
                                v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                                ref="scrollContainer"
                                style="min-height: 1px;"
                            >
                                <div 
                                v-for="(employee,index) in employees" :key="index" 
                                class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 employees-list-table-align employees-list-table">
                                    <div class="calls-table-row">
                                            <div class="calls-table-cell">
                                                <div class="o-right-side-padding5" @click="goToEmployeeDetails(employee)">
                                                    <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">
                                                        <div class="o-accordion-subtext user-icon o-list-user-img">
                                                            <div class="o-post-logged o-post-logged--table-user">
                                                                <div class="o-user-profile-img o-header-profile-pic">
                                                                    <div v-if="employee.employable">
                                                                        <img v-if="employee.employable.image && employee.employable.image != '' &&employee.employable.image != 'NULL'" :src="(employee.employable.image)"  id='img-upload'/>
                                                                        <img v-if="!employee.employable.image && employee.employable.image == '' ||employee.employable.image == 'NULL'" src="static/assets/images/user1.png" id='img-upload' />
                                                                    </div> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span>Name:
                                                                <el-tooltip v-if="isLoginSuper" class="item" effect="dark" content="Click to Copy Employee & User Id" placement="top-start">
                                                                    <a @click.stop="copyText('Employee Id: '+employee.id+' , User Id: '+employee.employable_id)"><i class="fa fa-paste"></i></a>
                                                                </el-tooltip>
                                                            </span>
                                                            <div>
                                                                <router-link style="text-decoration: none;" :to="{ name: `EmployeeDetails`, path: '/employeeDetails', params:{ employeeId: getEncodedId(employee.id) }}">
                                                                    {{employee.employable ? ((selectedSortType=='fname_asc')?employee.employable.first_name+" "+employee.employable.last_name:(selectedSortType=='fname_desc'?employee.employable.last_name+", "+employee.employable.first_name:employee.employable.first_name+" "+employee.employable.last_name)):'--'}}
                                                                </router-link>
                                                                <span v-if="employee.merge_notes">{{ employee.merge_notes }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>                                                
                                            </div>

                                            <div class="calls-table-cell">
                                                <div class="o-right-side-padding5 block-seniority" @click="navigateToEditEmployee(employee)" v-if="(employee.employee_status&&employee.employee_status.name) || employee.seniority">
                                                    <div class="display-status" v-if="employee.employee_status && employee.employee_status.name">
                                                            {{ employee.employee_status.name }}
                                                    </div>
                                                    <div class="calls-table-cell-inner-table" v-if="employee.seniority">
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span class="seniority-display">Sen: {{ getRoundOffSkillSeniority(employee.seniority) }}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="o-right-side-padding5" @click="navigateToEditEmployee(employee)" v-else>
                                                    <div class="display-add-status">
                                                        >> Add Status and Seniority
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="calls-table-cell">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <div>
                                                        <span>MS:</span>
                                                        <span class="ms-doh-text">{{employee.member_since && employee.member_since !== '0000-00-00 00:00:00' ? getUserDateFormat(employee.member_since):'  '}}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>DOH:</span>
                                                        <span class="ms-doh-text">{{employee.date_of_hire && employee.date_of_hire !== '0000-00-00 00:00:00'  ? getUserDateFormat(employee.date_of_hire):'  '}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right table-td-border-left o-left-side-padding5 o-right-side-padding5">
                                                    <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                        <div class="notify-icon">
                                                            <router-link :to="{ name: `Schedule`, path: '/schedule', params:{ empId: getEncodedId(employee.id) }}">
                                                                <i aria-hidden="true" class="fa fa-eye"></i>
                                                            </router-link>
                                                        </div>
                                                        <div class="notify-icon" v-if="employee.emergency_contact&&employee.emergency_contact.length&&checkEmergencyContactAvailable(employee)">
                                                            <a @click="viewEmergencyCard(employee)" href="javascript: void(0)" title="Emergency-Contact" class="plus-icon-display">
                                                                <img src="static/assets/images/hospital-plus.png" class="plus-icon" />
                                                            </a>
                                                        </div>
                                                        <div v-if="employee.resume_url" class="notify-icon">
                                                             <a @click="goToResume(employee.employable.id, employee.resume_url)">
                                                                <i aria-hidden="true" class="fa fa-graduation-cap"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Email ID:
                                                        <el-tooltip class="item" effect="dark" content="Click to Copy Email" placement="top-end">
                                                            <a @click.stop="copyText(employee.employable?employee.employable.email:'')"><i class="fa fa-paste"></i></a>
                                                        </el-tooltip>
                                                    </span>
                                                    <div>{{employee.employable ? employee.employable.email:'--'}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div  class="o-accordion-subtext o-rowtable-text">
                                                    <span>Phone:</span>
                                                    <div v-if="employee.employable">
                                                        <div v-for="(phone,phoneIndex) in employee.employable.phones" :key="phoneIndex">
                                                            <div v-if="phone.label=='Home phone' || phone.label=='home'">
                                                                <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="phone-number-display">
                                                                    {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Cell:</span>
                                                    <div v-if="employee.employable">
                                                        <div v-for="(phone,phoneIndex) in employee.employable.phones" :key="phoneIndex">
                                                            <div v-if="phone.label=='Cell phone' ||  phone.label=='mobile' || phone.label=='cell'">
                                                                <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="phone-number-display">
                                                                    {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="calls-table-cell" :class="getPower('notify')?'':'notify-tab-hide'">
                                            <div class="o-right-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text o-notify-cell" :class="getPower('notify')?'':'notify-tab-hide'">
                                                    <span class="">Notify</span>
                                                    <div class="notify-icon">
                                                        <a href="javascript: void(0)" @click="addBatchNotify(employee)"><i class="fa fa-mobile" aria-hidden="true"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="calls-table-cell" v-if="showCustom != 0 && customField1 != null && customField1 != '' && customField1 != 'NULL'">
                                            <div class="table-td-border-left o-left-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                     <span>
                                                     {{ customField1 ? customField1 : ''}}
                                                     </span>
                                                     <div>
                                                        <div>
                                                            {{ getCustomField1(employee.custom_field1) }}
                                                        </div>
                                                    </div>
                                                 </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell" v-if="showCustom != 0 && customField2 != null && customField2 != '' && customField1 != 'NULL'">
                                            <div class="table-td-border-left o-left-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                     <span>
                                                     {{customField2 ? customField2: ''}}
                                                     </span>
                                                     <div>
                                                        <div>
                                                            {{ getCustomField2(employee.custom_field2)&&getCustomField2(employee.custom_field2) != '' ? getCustomField2(employee.custom_field2) : "--"  }}
                                                        </div>
                                                    </div>
                                                 </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell text-center o-no-padding">
                                            <div class="o-edit-trash o-no-padding">

                                                <div class="o-table-block-btn">
                                                    <a :class="{'disabled':!getPower('editEmployee')}" href="javascript: void(0)" @click="editEmployee(employee)"><i class="fa fa-pencil" aria-hidden="true"></i></a>
                                                </div>
                                                <div class="o-table-block-btn">
                                                    <a href="javascript: void(0)" :class="(employeeId == employee.id || !getPower('deleteEmployee'))?'disabled':''" @click="deleteEmployees(employee.id)"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div v-if="employees.length==0 && afterApi" class="">
                    <div class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                        <div class="col-md-12 no-job-dispaly">
                            <i class="fa fa-frown-o" aria-hidden="true"></i>
                            <br />
                            No Data Stored
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <modal name="batch-notify"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
        <div class="modal-add-newJob" tabindex="-1" role="dialog">
            <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center o-small-modal-head">
                        <button @click="closeBatchNotify()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">Notify</h4>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-nopad-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <ul class="o-modal-tab">
                                    <li v-if="getNotificationType=='email'"><a href="javascript: void(0)" @click="notifyEmailTab()" :class="(notifyTab == 'email')?'o-tab-active':''">Email</a></li>
                                    <li v-if="getNotificationType=='sms'"><a href="javascript: void(0)" @click="notifySmsTab()" :class="(notifyTab == 'sms')?'o-tab-active':''">SMS</a></li>
                                </ul>
                            </div>
                            <div class="col-sm-12" v-if="notifyTab == 'email'">
                                <div class="form-group o-attachment-sec">

                                    <vue-editor 
                                        id="editor1" 
                                        class="c-common-box-shadow c-radius3" 
                                        :class="{ 'error-border': hasError }"
                                        v-model="emailContent"                                
                                        @text-change="validateContent('email', emailContent)"
                                    ></vue-editor>
                                    <span 
                                        v-if="error.email && error.email.hasError" 
                                        class="err-msg"
                                    > 
                                        {{ error.email.message }}
                                    </span>

                                    <div class="common-label-input--modalwidth o-upload-file attachment-btn-wrapper">
                                        <button class="btn o-attachment-icon"><i class="fa fa-paperclip" aria-hidden="true"></i></button>
                                        <input type="file" name="myfile" @change="attachmentAdded($event)">
                                        <span>{{(attachment)?attachment.name:'No file chosen'}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12" v-if="notifyTab == 'sms'">
                                <div class="o-sms-counter o-sms-counter-normal">{{smsContent.length}}/160</div>
                                <textarea 
                                    :maxlength="160"
                                    autocomplete="off"
                                    class="form-control o-no-radius notifySms-field" 
                                    :class="{ 'error-border': error.sms && error.sms.hasError }"
                                    v-model="smsContent"
                                    rows="10"
                                    placeholder="Type your SMS"
                                    @input="validateContent('sms', smsContent)"
                                ></textarea>
                                <span v-if="error.sms && error.sms.hasError" class="err-msg">
                                    {{ error.sms.message }}
                                </span>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="closeBatchNotify()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="sendNotify()" class="btn c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-paper-plane" aria-hidden="true"></i> Send</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </modal>
    <modal name="emg-notify"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
        <div class="modal-add-newJob" tabindex="-1" role="dialog">
            <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center o-small-modal-head">
                        <button @click="closeEmgNotify()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">Emergency Card</h4>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-nopad-body">
                        <div class="row">
                            <div class="col-sm-12">
                            Data
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="closeEmgNotify()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            
                        </ul>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
    </modal>
    <modal name="emergency-employee-card"  height="auto" :scrollable="false" class="modal-dialog modal-sm modal--custom">
        <div  tabindex="-1" role="dialog">
            <div  role="document">
                <div class="modal-content o-common-modal-content otb-modal-content">
                    <div class="modal-header text-center">
                        <button @click="closeEmergencyCardModal()" type="button" class="close otb-close custom-modal--close otb-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h1 class="modal-title otb-title">WARNING! HIGHLY PERSONAL and CONFIDENTIAL!</h1>
                    </div>
                    <div class="modal-body">
                        <div class="otb-conflict-body" v-if="emergencyContact">
                            <div class="row">
                                <div class="col-6 col-sm-6 col-md-4">
                                    <span class="emergency-label">Contact Name: </span>
                                </div>
                                <div class="col-6 col-sm-6 col-md-8">
                                    <span class="emergency-value">{{ emergencyContact && emergencyContact.contact_name && emergencyContact.contact_name != '' ? emergencyContact.contact_name : '' }}</span>
                                </div>
                            </div>
                            <!-- <div class=""> -->
                            <div class="row mt-40">
                                <div class="col-6 col-sm-6 col-md-4">
                                    <span class="emergency-label">Contact Number: </span>
                                </div>
                                <div class="col-6 col-sm-6 col-md-8">
                                    <a :href="'tel:'+getClientContactFormat(emergencyContact.contact_number)" v-if="emergencyContact&&emergencyContact.contact_number&&emergencyContact.contact_number!=''" class="phone-number-display">
                                        {{ emergencyContact.contact_number ? getClientContactFormat(emergencyContact.contact_number) : '' }}
                                    </a> 
                                    <span v-else class="emergency-value">-</span>
                                </div>
                            </div>
                            <div class="row mt-40">
                                <div class="col-6 col-sm-6 col-md-4">
                                    <span class="emergency-label">Home Phone: </span>
                                </div>
                                <div class="col-6 col-sm-6 col-md-8">
                                    <a :href="'tel:'+getClientContactFormat(emergencyContact.home_phone_no)" v-if="emergencyContact&&emergencyContact.home_phone_no&&emergencyContact.home_phone_no!=''" class="phone-number-display">
                                        {{ emergencyContact.home_phone_no ? getClientContactFormat(emergencyContact.home_phone_no) : '' }}
                                    </a>
                                    <span v-else class="emergency-value">-</span>
                                </div>
                            </div>
                            <div class="row mt-40">
                                <div class="col-6 col-sm-6 col-md-4">
                                    <span class="emergency-label">Cell Phone: </span>
                                </div>
                                <div class="col-6 col-sm-6 col-md-8">
                                    <a :href="'tel:'+getClientContactFormat(emergencyContact.cell_phone_no)" v-if="emergencyContact&&emergencyContact.cell_phone_no&&emergencyContact.cell_phone_no!=''" class="phone-number-display">
                                        {{ emergencyContact.cell_phone_no ? getClientContactFormat(emergencyContact.cell_phone_no) : '' }}
                                    </a>
                                    <span v-else class="emergency-value">-</span>
                                </div>
                            </div>
                            <div class="row mt-40">
                                <div class="col-6 col-sm-6 col-md-4">
                                    <span class="emergency-label">Medical Conditions: </span>
                                </div>
                                <div class="col-6 col-sm-6 col-md-8">
                                    <div class="emergency-medication-display">
                                        {{ emergencyContact.medical_conditions_note ? emergencyContact.medical_conditions_note : ' - ' }}
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-40">
                                <div class="col-6 col-sm-6 col-md-4">
                                    <span class="emergency-label">Regular Medications: </span>
                                </div>
                                <div class="col-6 col-sm-6 col-md-8">
                                    <div class="emergency-medication-display">
                                        {{ emergencyContact.regular_medications ? emergencyContact.regular_medications : ' - ' }}
                                    </div>
                                </div>
                            </div>
                            <!-- </div> -->
                        </div>   
                        <div class="otb-conflict-body" v-else>
                            <p class="text-center">
                                No Emergency Contact Details...
                            </p>
                        </div>
                    </div>                        

                    <div class="modal-footer text-center">
                        <a id="btn-bulk-assign-modal" href="javascript: void(0)" @click="closeEmergencyCardModal()" class="c-common-btn c-common-btn--small otb-modal-cancel-btn"> Cancel</a>
                    </div>
                
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
    </modal>
  </div>
</template>
<script>
    import { mapGetters } from 'vuex';
import { findContentProblems, describeContentProblems, stripHtml } from '../../contentRules.js';
    import dateTimeConvert from '../../timeConvert&Compare.js';
    import { VueEditor } from 'vue2-editor';
    import service from '../../services.js';
    import { buildNotifyMessage } from '../../utils/notifyStats.js';
    import { global } from '../../global.js';
    import { customFieldValue } from '../../customFieldRules.js';   // #2030

    export default {
        components: {
            VueEditor
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userClientID: 'userClientID',
                employeeId : 'employeeId',
				isLoginSuper: 'isLoginSuper'
            }),
        },
        data() {
            return {
                empProfile: '',
                getBaseURL: '',
                searchData: [],
                searchBox: '',
                employees: [],
                page_no: 3,
                savedEmployees: [],
                last_page: 0,
                next_page: "",
                search_query: "",
                tempStatus: "all",
                selectedStatusId: 'all',
                selectedSortType: '',
                selectedEmpId: [],
                statusList: [],
                emailContent: '',
                smsContent: '',
                notifyTab: 'email',
                customField1: '',
                customField2: '',
                showCustom: '',
                loading: false,
                afterApi: false,
                attachment : null,
                getNotificationType:'email',
                loadingShow: false,
                emergencyContact: null,
                hasError: false,
                error: {},
                // Onboarding profiles surfaced as "Add Templates" — default on top.
                templates: [],
                selectedTemplate: '',
            }
        },
        async beforeMount() {
            this.getBaseURL = global[0].IMAGE_URL;
            //this.sortEmployee();
            this.$Progress.start();
            this.loading=true;
            await service.get('employee/employee_status_lite', {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
                'cs3-context-clientId': this.userClientID
            }).
            then(async(res) => {
                this.statusList = res.data.result;
                this.$Progress.finish();
                this.statusList.sort(function(a, b) {
                    if (Number(a.priority) < Number(b.priority)) return -1;
                    if (Number(a.priority) > Number(b.priority)) return 1;
                    return 0;
                });
                this.selectedStatusId=this.statusList[0].id;
                this.tempStatus = this.selectedStatusId;
                await this.getClient();
                this.fetchTemplates();

            }).catch((err) => {
                console.log(err);
                this.$Progress.finish();
            });

        },
        methods: {
            getClientContactFormat(phone) {
                phone = phone ? phone.toString() : '';
                phone = phone.replace(/-/g, "");
                phone = phone.replace(/ /g, "");
                phone = phone.replace("(", "");
                phone = phone.replace(")", "");
                let result = '';
                if(phone&&phone.length==10) { 
                    // console.log(phone);
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    // console.log(phone);
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }
                return result;
                // return phone;
            },
            getRoundOffSkillSeniority(seniorityVal) {     
                // console.log(seniorityVal); 
                if(seniorityVal && seniorityVal != '') {          
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },
            getUserDateFormat(dateTime) {
                return dateTimeConvert.localDate(dateTime);
            },
            copyText(text){
                var textarea = document.createElement("textarea");
		        textarea.textContent = text;
		        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
		        document.body.appendChild(textarea);
		        textarea.select();
		        try {
		        	// console.log(textarea);
		            document.execCommand("copy");  // Security exception may be thrown by some browsers.
		            this.$notify({
                        title: this.$t('success'),
                        message: 'Copied to clipboard.',
                        type: 'success'
                    });
                    
		        } catch (ex) {
		            console.warn("Copy to clipboard failed.", ex);
		            return false;
		        } finally {
		            document.body.removeChild(textarea);
		        }
            },
            goToResume(user_id, url){
                if(!url){

                }else{
                    window.open(url, '_blank');
                }
            },
            attachmentAdded($event) {
              if($event.target.files.length != 0)
                this.attachment = $event.target.files[0];
              else
                 this.attachment = null;
            },
            viewSchedule(empId){
                this.$router.push({
                    'path': '/schedule/'+btoa(empId)
                });
            },
            viewEmergencyCard(employee) {
                console.log(employee);
                this.emergencyContact = employee.emergency_contact&&employee.emergency_contact.length?employee.emergency_contact[0]:null;
                this.$modal.show('emergency-employee-card');
            },
            closeEmergencyCardModal() {
                this.$modal.hide('emergency-employee-card');
            },
            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },
            // #2030 — one shared reader (src/customFieldRules.js). This was a
            // hand-rolled double JSON.parse copied into seven components, five of
            // them with no try/catch — so ONE malformed value blanked the page.
            getCustomField1(data) {
                return customFieldValue(data, '');
            },

            // #2030 — one shared reader (src/customFieldRules.js). This was a
            // hand-rolled double JSON.parse copied into seven components, five of
            // them with no try/catch — so ONE malformed value blanked the page.
            getCustomField2(data) {
                return customFieldValue(data, '');
            },

            sendNotify() {
                if(this.notifyTab == 'email') {
                    this.validateContent('email', this.emailContent);
                    if(this.error.email && this.error.email.hasError) {
                        this.$notify.error({
                            title: 'Error', 
                            message:'Please fix validation errors before saving.'}
                        ); 
                        return;
                    }
                } else {
                    this.validateContent('sms', this.smsContent);
                    if(this.error.sms && this.error.sms.hasError) {
                        this.$notify.error({
                            title: 'Error', 
                            message:'Please fix validation errors before saving.'}
                        ); 
                        return;
                    }
                }

                var formData;
                //let formData = {};
                if (this.notifyTab == 'email') {
                    formData = new FormData();
                    formData.append('email', this.emailContent);
                    formData.append('client_id', this.userClientID);
                    formData.append('employee_ids', JSON.stringify(this.selectedEmpId));
                    if(this.attachment != null || this.attachment == "")
                    {
                      formData.append("attachment", this.attachment);
                    }
                } else {
                    formData = {
                        sms: this.smsContent,
                        client_id: this.userClientID,
                        employee_ids: JSON.stringify(this.selectedEmpId)
                    };
                }

                service.post('employee/notifyEmployee', formData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'user-id': this.userID
                    })
                    .then((res) => {
                        this.$notify({
                            title: this.$t('success'),
                            message: buildNotifyMessage(res),
                            type: 'success'
                        });
                        this.$modal.hide('batch-notify');
                    }).catch((err) => {
                        console.log(err);
                        var errMsg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Notification failed to send';
                        this.$notify.error({ title: this.$t('error'), message: errMsg });
                    });
            },
            notifyEmailTab() {
                this.notifyTab = 'email';
            },
            notifySmsTab() {
                this.notifyTab = 'sms';
            },
            addBatchNotify(emp) {
                this.selectedEmpId = [];
                this.getNotificationType=emp.email_notification==1?'email':'sms';
                if(emp.email_notification==1){
                    this.getNotificationType='email';
                    this.notifyTab = 'email';
                }else{
                    this.getNotificationType='sms';
                    this.notifyTab = 'sms';
                }
                this.selectedEmpId.push(emp.id);
                this.emailContent = "";
                this.smsContent = "";
                this.$modal.show('batch-notify');
            },
            closeBatchNotify() {
                this.$modal.hide('batch-notify');
            },
            addEmgNotify() {
                this.$modal.show('emg-notify');
            },
            closeEmgNotify() {
                this.$modal.hide('emg-notify');
            },
           
            deleteEmployees(id) {
                this.$confirm('NAME will be removed from the records of CLIENT. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.del('employee/' + id, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.getAllEmployee();
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                    }).catch((err) => {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            getEmployeesBySearch() {

                if(this.search_query != '') {
                    if(this.search_query.length == 1 && this.selectedStatusId != 'all') {
                        this.tempStatus = this.selectedStatusId;
                        // console.log(this.tempStatus);
                    }
                    this.selectedStatusId = 'all'
                    this.getAllEmployee();
                }else {
                    // console.log(this.search_query.length);
                    this.selectedStatusId = this.tempStatus;
                    this.getAllEmployee();
                }
            },
            getAllEmployee() {
                clearTimeout(this.timeout);
                this.$Progress.start();
                this.loading = true;
                this.afterApi = false;
                this.employees=[];
                this.savedEmployees =[];
                var self = this;
                this.timeout = setTimeout(function () {
                    service.get('employee/getEmployeesByClient', {
                        'Authorization': self.userToken,
                        'cs3-context-role': self.userRole,
                        'cs3-context-clientId': self.userClientID,
                        'status': self.selectedStatusId,
                        'sort': self.selectedSortType,
                        'search': self.search_query,
                        'pagination': true
                    }).then((res) => {
                        self.employees = res.data.result.data;
                        //console.log("fffff", self.employees);
                        self.$Progress.finish();
                        self.last_page = res.data.result.total;
                        self.next_page = res.data.result.next_page_url;
                        self.loading = false;
                        self.afterApi = true;
                        //console.log("res", res.data.result.data[0].employable);
                        //self.sortEmployee();
                        if (self.next_page != null && self.next_page != "") {
                            service.getUrl(self.next_page, {
                                'Authorization': self.userToken,
                                'cs3-context-role': self.userRole,
                                'cs3-context-clientId': self.userClientID,
                                'status': self.selectedStatusId,
                                'sort': self.selectedSortType,
                                'search': self.search_query,
                                'pagination': true
                            }).then((res) => {
                                self.savedEmployees = res.data.result.data;
                                self.next_page = res.data.result.next_page_url;

                            }).catch((err) => {
                                console.log(err);
                            });
                        } 
                    }).catch((err) => {
                        console.log(err);
                        self.loading = false;
                        self.afterApi = true;
                    });

                }, 1000);
            },
            querySearch(queryString, cb) {
                //var searchData = this.searchBox;
                let searchItem = [];
                if (this.searchBox.length > 2) {
                    service.get('employee/searchEmployee', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'searchEmployee': this.searchBox
                    })
                    .then((res) => {
                        //this.searchData = res.data.result;
                        searchItem=[];
                        res.data.result.forEach(function(event) {
                            let temp = {
                                value: event.first_name + ' ' + event.last_name,
                                id: event.id,
                            };
                            searchItem.push(temp);
                        });
                        //console.log(res);
                    }).catch((err) => {
                        console.log(err);
                    })
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        //console.log(searchItem);
                        cb(searchItem);
                    }, 3000);
                }

            },
            handleSelect(item) {
                //console.log(item);
                this.$store.dispatch('selectEmployee', {
                    'id': item.id,
                    'name': item.value,
                    'type': ""
                });
                this.$router.push({
                    'path': '/schedule/'+btoa(item.id)
                });
                // this.$router.push({
                //     path: '/employeeDetails/' + btoa(item.id)
                // });

            },

            capitaliseFirst(str) {
                var lower = str.toLowerCase();
                return lower.replace(/(^| )(\w)/g, function(x) {
                    return x.toUpperCase();
                });
            },
            addEmployee() {
                this.$router.push({
                    'path': '/add-new-employee'
                });
            },
            // Load onboarding profiles for the "Add Templates" dropdown,
            // default profile first (then by name).
            async fetchTemplates() {
                try {
                    const res = await service.getUrl('/api/v3/onboarding/profiles');
                    const rows = (res && res.data && res.data.data) ? res.data.data : [];
                    rows.sort((a, b) => {
                        if (!!b.is_default - !!a.is_default) return !!b.is_default - !!a.is_default;
                        return String(a.profile_name || '').localeCompare(String(b.profile_name || ''));
                    });
                    this.templates = rows;
                } catch (e) {
                    this.templates = [];
                }
            },
            // Selecting a template starts the add-employee flow seeded with it.
            onTemplateSelect() {
                if (!this.selectedTemplate) return;
                this.$router.push({ path: '/add-new-employee', query: { template: this.selectedTemplate } });
            },
            deleteEmployee() {
                this.$router.push({
                    'path': '/deleteEmployee'
                });
            },
            editEmployee(employee) {
                this.$store.dispatch('setEditUserTab', 'personal');
                this.$router.push({
                    'path': '/editEmployee/'+btoa(employee.id)
                });
            },

            getData() {
                return "<p>Hello</p>";
            },

            async handleScroll(position) {               
                if (position !== "bottom") return; 
                await this.loadMore();
            },

            loadMore() {
                console.log("Load More Call triggered");
                var arr = this.employees;
                if (this.savedEmployees.length != 0) {
                    this.savedEmployees.forEach(function(entry) {
                        arr.push(entry);
                    })
                    this.savedEmployees=[];
                    if (this.next_page != null || this.next_page != "") {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'status': this.selectedStatusId,
                            'sort': this.selectedSortType,
                            'search': this.search_query,
                            'pagination': true
                        }).then((res) => {
                            this.savedEmployees = res.data.result.data;
                            this.page_no += 1;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                } else
                    this.savedEmployees = [];

                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });

            },
            goToEmployeeDetails(employee) {
                this.$store.dispatch('selectEmployee', {
                    'id': employee.id,
                    'name': employee.employable.first_name + ' ' + employee.employable.last_name,
                    'type': employee.employable_type
                });
                this.$router.push({
                    path: '/employeeDetails/' + btoa(employee.id)
                });
            },

            getEncodedId(id) {
                return btoa(id)
            },

            navigateToEditEmployee(employee){
                let employeeId=btoa(employee.id);
                this.$store.dispatch('setEditUserTab', 'admin');
                this.$router.push({
                    'path': '/editEmployee/' + employeeId,
                });
            },                                                   

            getPhone(phone) {
                if (!phone ||phone.length == 0)
                    return phone.length;
                else
                    return phone[0].phone_number;
            },
            async getClient(){
                await service.get('client/' + this.userClientID, {
                    'Authorization': this.userToken
                }).
                then((res) => {
                    //this.turnoverTime=res.data.result.turnover;

                    this.customField1 = res.data.result.custom_field_1;
                    this.customField2 = res.data.result.custom_field_2;
                    this.showCustom = res.data.result.employee_title;
                    this.selectedSortType=res.data.result.default_employee_sort != '' ? res.data.result.default_employee_sort : 'fname_asc';
                    this.getAllEmployee();
                }).catch((err) => {
                    console.log(err);
                });        
            },
            checkEmergencyContactAvailable(employee){
                let emergency_contact = employee.emergency_contact[0];
                let result = false;
                if(emergency_contact.contact_name!=''||emergency_contact.cell_phone_no!=''||emergency_contact.home_phone_no!=''||emergency_contact.medical_conditions_note!=''||emergency_contact.regular_medications!=''){
                    // contact_name,contact_number, medical_conditions_note,regular_medications,home_phone_no,cell_phone_no
                    result = true;
                }
                return result;
            },
            validateContent(fieldName, value) {
                // Initialize error object if it doesn't exist
                if (!this.error) {
                    this.$set(this, 'error', {});
                }
                
                // Reset error state for this field
                this.$set(this.error, fieldName, {
                    hasError: false,
                    message: ''
                });
                
                // Get plain text content (strip HTML tags)
                const plainText = this.getPlainText(value);
                
                // Only validate if there's content
                if (plainText.trim().length > 0) {
                    // #1952 — ed, 2026-09-30: "a, show it". Name every offender and where it
                    // is; never rewrite what the user pasted.
                    const problems = findContentProblems(plainText);
                    if (problems.length > 0) {
                        this.$set(this.error, fieldName, {
                            hasError: true,
                            problems: problems,
                            message: describeContentProblems(problems)
                        });
                    }
                }
            },
    
            getPlainText(html) {
                return stripHtml(html);   // #1952 — shared, was duplicated in ten files
            },
    
            // #1952 — one shared rule set (src/contentRules.js). This used to carry
            // four patterns inline, duplicated verbatim across ten components; two of
            // them rejected indentation, tabs, ---- dividers and ellipses.
            containsInvalidContent(text) {
                return findContentProblems(text).length > 0;
            },

            hasValidationErrors() {
                // Check if any field has errors
                if (!this.error) return false;
                
                return Object.values(this.error).some(error => error.hasError === true);
            },
        },
        
        async created() {
            
            this.notifyTab = this.getNotificationType;
        },
        mounted(){
            setTimeout(()=>{
                $('#search-input-employee').focus();  
            },200);
        }

    }

</script>
<style scoped>
    /* "Add Templates" dropdown + Add new Employee button, under the search box */
    .o-add-employee-bar {
        margin-top: 10px;
    }
    .o-add-employee-bar .o-add-template-select {
        margin-right: 8px;
        vertical-align: middle;
    }
    .o-add-employee-bar .o-add-employee-btn {
        vertical-align: middle;
    }
    .err-msg {
        margin: 2px;
        color: red
    }
    .mt-40 {
        margin-top: 20px;
    }
    .plus-icon-display {        
        height: 30px;
        width: 30px;
        padding: 3px 0 0 0;
        display: block;
        text-align: center!important;
        border: 3px solid #ebebeb;
        border-radius: 50%;
        background-color: #f5f5f5;
        margin-left: 20%;
        margin-top: 5px;
    }
    .plus-icon {
        height: 20px;
    }
    .modal-title{
        color: #ffffff!important;
    }
    .otb-modal-content {
        border-radius: 4px !important;
        padding: 0px!important;
        background-color: #ffffff;
        border: 2px solid #F67801!important;
    }

    .otb-title {
        padding: 5px;
        font-size: 18px;
        font-weight: bold;
        color: #000000;
        background-color: #F67801;
        border-bottom: 2px solid #F67801;
    }

    .otb-close {
        text-shadow: 0 0 0 #000000!important;
        font-size: 15px;
        color: #ffffff!important;
    }

    .otb-modal--close {
        opacity: 1;
        position: absolute;
        right: 10px;
        top: 8px;
        font-size: 20px;
        width: 20px;
        height: 20px;
        background-color: #F67801!important;
        color: #ffffff!important;
        padding: 0 !important;
        text-shadow: #000000!important;
        /* border: 2px #000 solid; */
        margin-top: 0;
    }

    .otb-modal-cancel-btn {
        background-color: #F67801;
        color: #ffffff;
        margin-right: 20px;
        padding: 10px 15px;
    }
    .otb-modal-proceed-btn {
        background-color: #17A068;
        color: #ffffff;
        margin-right: 20px;
        padding: 10px 15px;
    }
    .otb-conflict-body {
        line-height: 1.5;
        font-size: 15px;
        font-weight: 500;
        padding: 10px 10px 0;
    }
    .mt-15{
        margin-top: 15px;
    }
    .o-red-icon i {
        font-size: 25px;
    }
    .phone-number-display{
        padding: 5px;
        cursor: pointer;
        color: #222222;
        text-decoration: none !important;
    }
    .emergency-medication-display {
        display: block;
        padding: 5px;
        color: #222222;
        border: 1px solid #444444;
        border-radius: 5px;
        width: 90%;
        height: 75px;
        margin-bottom: 3px;
        text-decoration: none !important;
        background-color: #e0e0e0;
        overflow-y: auto;
    }
    .ms-doh-text {
        color: #000000!important;
    }
    .block-seniority {
        padding: 0 2px;
        /* background-color: #D5EDF9; */
        cursor: pointer;
    }

    .display-add-status{
        text-align: right;
        width: 140px;
        padding: 2px;
        /* background-color: #17A068; */
        color: #17A068;
        cursor: pointer;
    }
    .seniority-display{
        margin-top: 2px;
        width: 140px;
        text-align: center;
    }
    .display-status{
        width: 140px;
        border-radius: 4px;
        text-align: center;
        padding: 2px 5px;
        /* background-color: #ffffff; */
        cursor: pointer;
    }
    .emp-schedule-eye-btn{
        padding: 1px 5px;
        background-color: #111e2c;
        color: white !important;
        border-radius: 3px;
        margin-right: 5px;
        font-size: 19px;
    }
    .emp-resume-cap-btn{
        padding: 2px 4px;
        background-color: #111e2c;
        color: white !important;
        border-radius: 3px;
        margin-right: 5px;
        font-size: 17px;
    }
    .pointHere {
        cursor: pointer;
    }

    .tooltip {
        display: block !important;
        z-index: 10000;
    }

    .tooltip .tooltip-inner {
        background: #f9ffb5;
        color: black;
        border-radius: 16px;
        padding: 5px 10px 4px;
    }

    .tooltip .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: #f9ffb5;
    }

    .tooltip[x-placement^="top"] {
        margin-bottom: 5px;
    }

    .tooltip[x-placement^="top"] .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }

    .tooltip[x-placement^="bottom"] {
        margin-top: 5px;
    }

    .tooltip[x-placement^="bottom"] .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }

    .tooltip[x-placement^="right"] {
        margin-left: 5px;
    }

    .tooltip[x-placement^="right"] .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip[x-placement^="left"] {
        margin-right: 5px;
    }

    .tooltip[x-placement^="left"] .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity .15s, visibility .15s;
    }

    .tooltip[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity .15s;
    }

</style>
